import { AppointmentId } from '@dreryk/egabinet-appointment-published-language-api';
import { VisitSettlement, VisitSettlementQuery } from '@dreryk/egabinet-financial-settlement-frontend-api';
import { PurchaseId } from '@dreryk/egabinet-financial-settlement-published-language-api';

import { useCqrsFind } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType, StyledMargin } from '@dreryk/react-components';

import { visitSettlementTranslationKeys } from '../../../../translations';

type MedicalServicesTableLoaderRenderProps = { visitSettlement: VisitSettlement | null };

type MedicalServicesTableLoaderProps = {
   readonly appointmentId: AppointmentId;
   readonly children: (renderProps: MedicalServicesTableLoaderRenderProps) => JSX.Element;
};

export const MedicalServicesTableLoader = (props: MedicalServicesTableLoaderProps): JSX.Element => {
   const {
      data: visitSettlement,
      loading: visitSettlementLoading,
      error: visitSettlementError,
   } = useCqrsFind<VisitSettlement>(() => {
      const query = new VisitSettlementQuery();
      query.purchaseIds = [PurchaseId.forAppointment(props.appointmentId)];
      return query;
   });

   if (visitSettlementLoading) {
      return (
         <StyledMargin top={12} bottom={12}>
            <LoaderSpinner />
         </StyledMargin>
      );
   }

   if (visitSettlementError) {
      return (
         <Message
            testId={'visitSettlementFetchError'}
            type={MessageType.NEGATIVE}
            label={visitSettlementTranslationKeys.extensions.visitHistory.medicalServicesTab.errors.fetch}
            displayIndicator
         />
      );
   }

   return props.children({
      visitSettlement: visitSettlement,
   });
};
